<ng-template [ngIf]="source">
    <div class="img-wrapper" [ngStyle]="wrapperStyle">
        <img [src]="source" width="auto" height="auto" [alt]="alt" [ngStyle]='style' 
        onerror="this.onerror=null;this.src='assets/img/img_404.png';" loading="lazy"/>
    </div>
</ng-template>